export const AreaOfInterest =[
    // {Id:0,Name:'Select'},
    {Id:"Physics" , Name:"Physics"},
    {Id:"Chemistry" ,Name:"Chemistry"},
    {Id:"Mathematics" , Name:"Mathematics"},
    {Id:"Botany" , Name:"Botany"},
    {Id:"Zoology" , Name:"Zoology"},
    {Id:"Geology" , Name:"Geology"},
    {Id:"IT/Computer Science" , Name:"IT/Computer Science"},

    {Id:"Commerce" , Name:"Commerce"},

    {Id:"Education" , Name:"Education"},
    {Id:"Odia" , Name:"Odia"},
    {Id:"Sociology" , Name:"Sociology"},
    {Id:"Political Science" , Name:"Political Science"},
    {Id:"History" , Name:"History"},
    {Id:"Sanskrit" , Name:"Sanskrit"},
    {Id:"Hindi" , Name:"Hindi"},
    {Id:"English" , Name:"English"},
    {Id:"Economics" , Name:"Economics"},

    {Id:"MBA/MFC/BBA" , Name:"MBA/MFC/BBA"},
    {Id:"MCA/BCA" , Name:"MCA/BCA"},
    {Id:"MSW" , Name:"MSW"},
    {Id:"M.Lib.Sc/B.Lib.Sc" , Name:"M.Lib.Sc/B.Lib.Sc"},
    ]
    
    
    export default AreaOfInterest;
    